import { DtoRequestAprvsPostReq } from "./abst/DtoRequestAprvsPostReq";
import { EntityRequest } from "../entity/EntityRequest";

export class DtoRequestAprvsPostReqImple extends DtoRequestAprvsPostReq {
  public request = new EntityRequest();

  public IsValidImple(chkPager: boolean): string[] {
    let res: string[] = new Array();
    //ページャー用入力値チェック

    return res;
  }
}
